import { PspDrawer } from "@/components/pspDrawer/pspDrawer";
import { translate } from "@/config/translator";
import { useNotificationsButton } from "./notificationsButton/useNotificationsButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/pro-regular-svg-icons";
// eslint-disable-next-line max-len
import { NotificationListElement } from "@/components/notificationListElement/notificationListElement";
import { Fragment } from "react/jsx-runtime";
import { clsx } from "clsx/lite";

export function NotificationsButton() {
  const {
    lang,
    notificationsOpen,
    setNotificationsOpen,
    notifications,
    hasNewNotification,
    markAllAsRead,
    setNotificationRead,
    updateHasNewNotifications,
    removeNotification,
    isInBackoffice,
  } = useNotificationsButton();

  return (
    <>
      <button
        className={clsx(
          "cursor-pointer",
          "group",
          "duration-200",
          "ease-in-out",
          "rounded-lg",
          "relative",
          "aspect-square",
          "p-2",
          isInBackoffice
            ? "hover:bg-canvas-secondary-dark"
            : "hover:bg-canvas-secondary",
        )}
        onClick={() => setNotificationsOpen((prev) => !prev)}
      >
        <FontAwesomeIcon
          className={clsx(
            "text-2xl",
            isInBackoffice ? "text-font-secondary-dark" : "text-font-black",
          )}
          icon={faBell}
        />

        {/* NEW NOTIFICATION DOT */}
        {hasNewNotification && (
          <div
            className="
              absolute
              bottom-0
              right-0
              size-4
              rounded-full
              bg-primary
              border-white
              border-2
            "
          />
        )}
      </button>
      {/* NOTIFICATIONS DRAWER */}
      <PspDrawer
        title={translate("notifications", lang)}
        subTitle={
          <button
            onClick={markAllAsRead}
            className="underline text-primary cursor-pointer"
          >
            {translate("markAllAsRead", lang)}
          </button>
        }
        isOpen={notificationsOpen}
        onClose={() => setNotificationsOpen(false)}
      >
        <div className="w-full flex flex-col gap-4">
          {notifications?.map((notification, index) => (
            <Fragment key={`notification-drawer-element-${notification.id}`}>
              <NotificationListElement
                removeNotification={removeNotification}
                type="desktop"
                closeNotificationDrawer={() => setNotificationsOpen(false)}
                notification={notification}
                setNotificationRead={setNotificationRead}
                updateHasNewNotifications={updateHasNewNotifications}
              />
              {index !== notifications.length - 1 && (
                <div className="w-full h-px bg-neutral" />
              )}
            </Fragment>
          ))}
        </div>
      </PspDrawer>
    </>
  );
}
